import { SidebarLayout } from 'layouts/Sidebar/SidebarLayout';
import { Form, Formik } from 'formik';
import { SucursalCampos } from './SucursalCampos';
import { Divider } from '@mui/material';
import { SucursalResiduos } from './SucursalResiduos.jsx';
import { useSucursal } from '../hooks/useSucursal';
import { schemaNuevaSucursal } from '../schema/schemaNuevaSucursal';
import ButtonComponent from 'components/design-system/Button/Button';
import Heading from 'components/design-system/Heading/Heading';
import Text from 'components/design-system/Text/Text';
import { ChevronLeft, Close } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import { SucursalSkeleton } from './SucursalSkelenton';
import IconButtonComponent from 'components/design-system/IconButton/IconButton';
import { DICTONARY } from 'const/Dictonary';
import { useHistory } from 'react-router-dom';
import { AlertaError } from 'utils/Alertas';
import { useContext } from 'react';
import { AuthContext } from 'context';

const SucursalFormik = () => {
  const {
    isTienePermisos,
    perfiles: { isSuperAdmin }
  } = useContext(AuthContext);
  const { codigoSucursal, codigoEmpresa } = useParams();
  const history = useHistory();
  const {
    isLoading,
    sucursal,
    isNuevaSucursal,
    tipoResiduoSeleccionados,
    handleSubmit
  } = useSucursal(codigoSucursal || null, codigoEmpresa || null);

  window.scrollTo(0, 0);

  return (
    <SidebarLayout>
      <Heading type="h3" className="mb-5">
        <IconButtonComponent
          onClick={() => history.goBack()}
          type="secondary"
          className="mr-2"
        >
          <ChevronLeft />
        </IconButtonComponent>

        {isNuevaSucursal ? 'Nueva sucursal' : 'Editar sucursal'}
      </Heading>
      <div className="bg-white rounded shadow-md p-5 mb-10">
        {isLoading ? (
          <SucursalSkeleton />
        ) : (
          <Formik
            initialValues={sucursal}
            validateOnMount={false}
            validationSchema={schemaNuevaSucursal(isTienePermisos)}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={(values, { setSubmitting }) => {
              try {
                handleSubmit(values).finally(() => {
                  setSubmitting(false);
                });
              } catch (error) {
                AlertaError(
                  'Ha ocurrido un error al guardar los datos vuelve a intentarlo recargando la página y completando nuevamente el formulario. Si el problema persiste comunícate con el administrador del sitio'
                );
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              setFieldValue,
              setFieldTouched,
              isSubmitting,
              handleBlur,
              handleChange
            }) => (
              <Form id="editarSucursal" onChange={() => {}}>
                <SucursalCampos
                  values={values}
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  isSubmitting={isSubmitting}
                  isTienePermisos={isTienePermisos}
                  codigoEmpresa={codigoEmpresa}
                  isSuperAdmin={isSuperAdmin}
                  handleBlur={handleBlur}
                />

                <SucursalResiduos
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  tipoResiduoSeleccionados={tipoResiduoSeleccionados}
                />

                {errors.codigosTipoResiduo && touched.codigosTipoResiduo && (
                  <Text className="text-error-dark py-2">
                    <Close className="mr-1 text-lg" />
                    {errors.codigosTipoResiduo}
                  </Text>
                )}

                <div className="col-span-12 my-5">
                  <Divider />
                </div>

                <div className="col-span-12 justify-between">
                  <div className="flex flex-col sm:flex-row justify-between">
                    <ButtonComponent
                      onClick={() => history.goBack()}
                      className="w-full sm:w-auto mt-4 sm:mt-0 order-2 md:order-1"
                      type="secondary"
                    >
                      Cancelar
                    </ButtonComponent>
                    <ButtonComponent
                      form="editarSucursal"
                      buttonType="submit"
                      isLoading={isSubmitting}
                      disabled={isSubmitting}
                      className="w-full sm:w-auto order-1 md:order-2"
                    >
                      {isSubmitting
                        ? isNuevaSucursal
                          ? DICTONARY.MENSAJES_BOTONES_ACCIONES_CRUD
                              .INGRESAR_IS_LOADING
                          : DICTONARY.MENSAJES_BOTONES_ACCIONES_CRUD
                              .EDITAR_IS_LOADING
                        : isNuevaSucursal
                        ? DICTONARY.MENSAJES_BOTONES_ACCIONES_CRUD.INGRESAR
                        : DICTONARY.MENSAJES_BOTONES_ACCIONES_CRUD.EDITAR}
                    </ButtonComponent>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </div>
    </SidebarLayout>
  );
};

export default SucursalFormik;
